import { render } from "./SocialModal.vue?vue&type=template&id=8b2bb4ca&scoped=true"
import script from "./SocialModal.vue?vue&type=script&lang=js"
export * from "./SocialModal.vue?vue&type=script&lang=js"

import "./SocialModal.vue?vue&type=style&index=0&id=8b2bb4ca&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2bb4ca"]])

export default __exports__